<h3 class="text-center width-100">
  Showcase
  <i
    class="fa fa-times pull-right close-sidenav"
    aria-hidden="true"
    title="Close Text Block"
    (click)="closeNav()"
  ></i>
</h3>

<!--
    Static Showcase
-->
<div class="container-fluid" *ngIf="showcaseType === 'static'">
  <div class="edit row">
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="name">Title</label>
        <input
          type="text"
          class="form-control"
          id="name"
          aria-describedby="title"
          placeholder="Enter Title"
          [(ngModel)]="title"
        />
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="titleBackground">Title Background Color</label><br />
        <input
          type="text"
          class="form-control color"
          id="titleBackground"
          aria-describedby="Font Color"
          placeholder="Background Color"
          [(ngModel)]="titleBackground"
        />
        <button
          role="button"
          type="button"
          aria-label="Change Color"
          class="btn btn-circle"
          [style.background]="titleBackground"
          [(colorPicker)]="titleBackground"
        ></button>
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div class="form-check">
        <mat-checkbox (change)="setAutoPlay($event)" [(ngModel)]="autoplay" name="Auto Play"
          >Auto Play</mat-checkbox
        >
      </div>
    </div>
    <div class="col-12 margin-5-0" *ngIf="!isPopularList">
      <div class="form-group">
        <h6>Select a List for Showcase</h6>
        <mat-radio-group [(ngModel)]="listId" *ngIf="lists">
          <mat-radio-button class="width-100" *ngFor="let list of lists" [value]="list.listId">
            <span class="wrap-text">
              {{ list.listName }}
            </span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>
  <div class="edit row">
    <div class="col-12 margin-5-0 padding-0-10">
      <button
        role="button"
        type="button"
        aria-label="More Options"
        class="btn btn-link"
        (click)="isCollapsed = !isCollapsed"
      >
        More Options
        <i *ngIf="isCollapsed" class="fa fa-caret-right" aria-hidden="true"></i>
        <i *ngIf="!isCollapsed" class="fa fa-caret-down" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <div class="width-100 padding-0-25" [ngbCollapse]="isCollapsed">
    <div class="block row text-center margin-0">
      <h3>
        Design Elements
        <i
          class="fa fa-question-circle-o"
          aria-hidden="true"
          style="margin-left: 5px"
          matTooltip="Change the overall Font and Background Color, flush out margins in template, and add additional classes for this component."
          [matTooltipPosition]="'right'"
        >
        </i>
      </h3>
    </div>
    <div class="edit row">
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="color">Font Color</label><br />
          <input
            type="text"
            class="form-control color"
            id="color"
            aria-describedby="Font Color"
            placeholder="Font Color"
            [(ngModel)]="color"
          />
          <button
            role="button"
            type="button"
            aria-label="Change Color"
            class="btn btn-circle"
            [style.background]="color"
            [(colorPicker)]="color"
          ></button>
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="background">Background Color</label><br />
          <input
            type="text"
            class="form-control color"
            id="background"
            aria-describedby="Background"
            placeholder="Background Color"
            [(ngModel)]="background"
          />
          <button
            role="button"
            type="button"
            aria-label="Change Color"
            class="btn btn-circle"
            [style.background]="background"
            [(colorPicker)]="background"
          ></button>
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div class="form-check">
          <label class="form-check-label">
            <input
              style="
                width: 20px;
                height: 20px;
                margin-right: 5px;
                position: relative;
                vertical-align: bottom;
              "
              type="checkbox"
              class="form-check-input"
              id="flush"
              [(ngModel)]="flushed"
            />Flush in template.
          </label>
        </div>
        <hr class="padding-5" />
      </div>
    </div>
  </div>
  <!--
        ACTION BUTTONS
    -->
  <div class="width-100 text-center padding-0-15 background-color">
    <div class="padding-10 text-end">
      <button
        role="button"
        aria-label="Submit Showcase"
        *ngIf="showcaseType === 'static'"
        type="submit"
        class="btn btn-primary"
        (click)="doListShow()"
      >
        Submit Showcase
      </button>
    </div>
  </div>
</div>

<!--
    DYnamic Showcase
-->

<!-- 3 STEP PROCESS FORM: SETTINGS, SEARCH LISTING, AND LISTING RESULTS -->
<div class="container-fluid" *ngIf="showcaseType === 'dynamic'">
  <div class="edit row">
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="name">Title</label>
        <input
          type="text"
          class="form-control"
          id="name"
          aria-describedby="title"
          placeholder="Enter Title"
          [(ngModel)]="title"
        />
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="titleBackground">Title Background Color</label><br />
        <input
          type="text"
          class="form-control color"
          id="titleBackground"
          aria-describedby="Font Color"
          placeholder="Background Color"
          [(ngModel)]="titleBackground"
        />
        <button
          role="button"
          type="button"
          aria-label="Change Color"
          class="btn btn-circle"
          [style.background]="titleBackground"
          [(colorPicker)]="titleBackground"
        ></button>
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div class="form-check">
        <mat-checkbox (change)="setAutoPlay($event)" [(ngModel)]="autoplay" name="Auto Play"
          >Auto Play</mat-checkbox
        >
      </div>
    </div>
    <div class="width-100 margin-10-0 text-center" *ngIf="recordsCount > -1">
      <div class="total-records">
        Total Records Found : {{ recordsCount }}
        <i
          class="fa question-help fa-question-circle-o"
          aria-hidden="true"
          matTooltip="To Narrow Results enter a search term in Advance Search, Choose different Resources or Refine your search, and Submit Showcase to see it on your page."
          [matTooltipPosition]="'right'"
        >
        </i>
      </div>
    </div>
    <!-- ADVANCED SEARCH -->
    <ag-advanced-search
      #advanceShowcase
      [showcase]="true"
      [grid]="false"
      [embeddedComponent]="true"
      [template]="template[compArray]"
      (count)="recordsFound($event)"
    >
    </ag-advanced-search>

    <div class="edit row">
      <div class="col-12 margin-5-0 padding-10">
        <button
          role="button"
          type="button"
          aria-label="More Options"
          class="btn btn-link"
          (click)="isCollapsed = !isCollapsed"
        >
          More Options
          <i *ngIf="isCollapsed" class="fa fa-caret-right" aria-hidden="true"></i>
          <i *ngIf="!isCollapsed" class="fa fa-caret-down" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="width-100 padding-0-25" [ngbCollapse]="isCollapsed">
      <div class="block row text-center margin-15-0">
        <h3>
          Design Elements
          <i
            class="fa fa-question-circle-o"
            aria-hidden="true"
            style="margin-left: 5px"
            matTooltip="Change the overall Font and Background Color, flush out margins in template, and add additional classes for this component."
            [matTooltipPosition]="'right'"
          >
          </i>
        </h3>
      </div>
      <div class="edit row">
        <div class="col-12 margin-5-0">
          <div class="form-group">
            <label for="color">Font Color</label><br />
            <input
              type="text"
              class="form-control color"
              id="color"
              aria-describedby="Font Color"
              placeholder="Font Color"
              [(ngModel)]="color"
            />
            <button
              role="button"
              type="button"
              aria-label="Change Color"
              class="btn btn-circle"
              [style.background]="color"
              [(colorPicker)]="color"
            ></button>
          </div>
        </div>
        <div class="col-12 margin-5-0">
          <div class="form-group">
            <label for="background">Background Color</label><br />
            <input
              type="text"
              class="form-control color"
              id="background"
              aria-describedby="Background"
              placeholder="Background Color"
              [(ngModel)]="background"
            />
            <button
              role="button"
              type="button"
              aria-label="Change Color"
              class="btn btn-circle"
              [style.background]="background"
              [(colorPicker)]="background"
            ></button>
          </div>
        </div>
        <div class="col-12 margin-5-0">
          <div class="form-check">
            <label for="flush" class="form-check-label">
              <input
                style="
                  width: 20px;
                  height: 20px;
                  margin-right: 5px;
                  position: relative;
                  vertical-align: bottom;
                "
                type="checkbox"
                class="form-check-input"
                id="flush"
                [(ngModel)]="flushed"
              />Flush in template.
            </label>
          </div>
          <hr class="padding-5" />
        </div>
      </div>
    </div>
    <!--
        ACTION BUTTONS
    -->
    <div class="width-100 text-center padding-15 background-color">
      <!-- Submit Dynamic and List Showcase -->
      <div class="padding-10 text-end">
        <button
          role="button"
          type="button"
          aria-label="Submit Showcase"
          *ngIf="showcaseType === 'dynamic'"
          class="btn btn-primary"
          (click)="saveShowCase()"
          [disabled]="recordsCount === 0"
        >
          Submit Showcase
        </button>
      </div>
    </div>
  </div>
</div>
